import { getApiClient } from '../../services';

export default function fetchEncryptionKey(organizationId: string): Promise<string> {
  return getApiClient().publicKey.getLatest({ organization: organizationId })
    .then((response) => {
      if (response.ok) {
        return response.body.id;
      }
      throw new Error('fetchEncryptionKey: Fetch failed');
    });
}
